import type { ButtonProps } from '@mui/material/Button';

import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';

import Button from '@mui/material/Button';

import { signOutWithMsal } from '../../auth/context';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  const { instance } = useMsal();
  const handleLogout = useCallback(async () => {
    try {
      const redirectPromise = signOutWithMsal(instance);
      onClose?.();
      await redirectPromise;
    } catch (error) {
      console.error(error);
    }
  }, [instance, onClose]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      Logout
    </Button>
  );
}
